import React from "react";
import "./Spinner.scss";
import { Spinner } from "@softura/fluentuipackage";

const styles = {
  root: {
    position: "fixed",
    top: 0,
    right: 0,
    zIndex: 99999999999999,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
  },
};

interface IProps {
  text?: string;
}

const SpinnerComponent = ({ text, ...props }: IProps) => {
  return (
    <div className="approval-loader">
      <Spinner styles={styles} label={text} {...props}  data-attribute="index_text_Spinner" />
    </div>
  );
};

export default SpinnerComponent;
